import React, { useEffect, useState } from "react";
import '../styles/departments.css';
import PageHeader from "../components/PageHeader";
import { Api } from "../api/Api";
import useCustomNavigate from '../hooks/useCustomNavigate';
import { showToast } from "../helpers/UIHelper";
import { Spin } from "antd";
import useCustomParams from "../hooks/useCustomParams";

const Departments = () => {
    const [departments, setDepartments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filteredDepartments, setFilteredDepartments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigateCustom = useCustomNavigate();
    const params = useCustomParams();
    useEffect(() => {
        if (!params.forOtherPatient) {
            localStorage.removeItem("life-other-patient")
        }
        try {
            Api.get('/api/mobileappointmentdeptwiseinfo/?siteid=2&patientid=').then((response) => {
                if (response.data && response.data.Department_List) {
                    setDepartments(response.data.Department_List);
                    setFilteredDepartments(response.data.Department_List);
                } else {
                    showToast('error','No departments found.')
                }
                setIsLoading(false);
            }).catch((e)=>{
                console.error('Error fetching departments:', e);
            })
        } catch (err) {
            showToast('error','Failed to load departments.');
            setIsLoading(false);
        }
    }, []);
    const filter = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        if (value === "") {
            setFilteredDepartments(departments);
        } else {
            const filtered = departments.filter(dept => dept.dep_name.toLowerCase().includes(value));
            setFilteredDepartments(filtered);
        }
    }
    const handleNavigation = (departmentName,departmentId,isspeciality ) => {
        navigateCustom('/appointment',{departmentId:departmentId,isSpeciality:isspeciality, departmentName:departmentName});
    };
    return (
        <div className="departments-page">
            <PageHeader title="Departments" />
            <div className="page-sub-title">
                Select Department
            </div>
            {!isLoading ?
                <>
                    <div className="search-department">
                        <div>
                            <input type="text" onChange={filter} value={searchTerm} />
                            <i className="las la-search"/>
                        </div>
                    </div>
                    <div className="department-list">
                        {filteredDepartments.map((dept, index) =>
                            <div className="department-item" key={index} onClick={() => handleNavigation(dept.dep_name, dept.dep_id, true)}>
                                {dept.dep_name}
                            </div>
                        )}
                    </div>
                </> :
                <div className="loading">
                    <Spin/>
                </div>
            }
        </div>
    )
}
export default Departments;